import { HttpInterceptorFn } from '@angular/common/http';
import { SKIP_HTTP_CREDENTIALS } from '../http/http-context.tokens';

export const Interceptor : HttpInterceptorFn = (req, next) => {
  const skipCredentials = req.context.get(SKIP_HTTP_CREDENTIALS);
  if (skipCredentials) {
    return next(req.clone({ withCredentials: false }));
  }

  const token = localStorage.getItem('authToken');
  const headers: Record<string, string> = {};

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const authReq = req.clone({
    withCredentials: true,
    setHeaders: headers
  });
 
  return next(authReq);
};
